export default __webpack_public_path__ + "static/media/gift_cards.0dc407a3.svg";